import { computed, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import Report from "@/services/analytics/report";
import type { OpportunityDashboardRequestBody } from "./useOpportunityDashboardFilters";

export function useOpportunityDashboard(params: Ref<OpportunityDashboardRequestBody | null>) {
  const queryKey = computed(() => {
    const p = params.value;
    if (!p) return ["opportunityDashboard", "disabled"];
    return ["opportunityDashboard", JSON.stringify(p)];
  });

  const enabled = computed(() => {
    return params.value !== null && !!params.value.organizationId;
  });

  return useQuery({
    queryKey,
    queryFn: async () => {
      const p = params.value;
      if (!p) throw new Error("Parameters not ready");

      const response = await Report.getOpportunityDashboard(p);

      if (response.data?.status && response.data?.data) {
        return response.data.data;
      }

      throw new Error(response.data?.message || "Failed to load dashboard data");
    },
    enabled,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
